import React, { Fragment } from "react";

const websiteName = ({ type, url, text }) => {
  if (text) return text;

  const lowerUrl = url.toLowerCase();
  const isFbOrIg =
    lowerUrl.indexOf("facebook") > -1 || lowerUrl.indexOf("instagram") > -1;

  if (isFbOrIg) return lowerUrl.split("//")[1].split("www.")[1];

  return lowerUrl;
};

const WebsiteList = ({ websites }) => {
  const filteredSites = websites.filter(
    (site) => site.type !== "GoogleMapsLink"
  );

  if (!filteredSites || filteredSites.length === 0) {
    return <></>;
  }

  return (
    <>
      {filteredSites.map((site, index) => (
        <Fragment key={index}>
          <h4>{site.type}</h4>
          <p>
            <a href={site.url} target="_new">
              {websiteName(site)}
            </a>
          </p>
        </Fragment>
      ))}
    </>
  );
};

export default WebsiteList;
